import { render } from "./allPopups.vue?vue&type=template&id=3074031a"
import script from "./allPopups.vue?vue&type=script&lang=js"
export * from "./allPopups.vue?vue&type=script&lang=js"

import "./allPopups.vue?vue&type=style&index=0&id=3074031a&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__